module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab105-1b1c80d1d1697487dc767a51a4ceb779.jpg";